export const APIARIES_LIST_VIEW = "/apiaries"
export const APIARY_VIEW = `${APIARIES_LIST_VIEW}/:apiaryId`
export const NEW_APIARY_VIEW = APIARIES_LIST_VIEW + "/new"
export const EDIT_APIARY_VIEW = APIARY_VIEW + "/edit"

export const HIVES_LIST_VIEW = "/hives"
export const NEW_HIVE_FOR_APIARY_VIEW =
  `${APIARIES_LIST_VIEW}/:apiaryId${HIVES_LIST_VIEW}` + "/new"
export const NEW_HIVE_VIEW = HIVES_LIST_VIEW + "/new"
export const HIVE_VIEW = `${APIARIES_LIST_VIEW}/:apiaryId${HIVES_LIST_VIEW}/:hiveId`
export const EDIT_HIVE_VIEW = HIVE_VIEW + "/edit"

export const QUEENS_LIST_VIEW = `/queens`
export const APIARY_HIVE_BASE_VIEW = `${APIARIES_LIST_VIEW}/:apiaryId${HIVES_LIST_VIEW}/:hiveId/queen`
export const APIARY_HIVE_QUEEN_VIEW = `${APIARY_HIVE_BASE_VIEW}/:queenId`
export const NEW_QUEEN_FOR_HIVE_VIEW = `${APIARY_HIVE_BASE_VIEW}/new`
export const EDIT_QUEEN_VIEW = `${QUEENS_LIST_VIEW}/:queenId/edit`
export const QUEEN_VIEW = `${QUEENS_LIST_VIEW}/:queenId`
export const NEW_QUEEN_VIEW = QUEENS_LIST_VIEW + "/new"

export const HIVE_SCALE_LIST_VIEW = "/hive-scales"
export const HIVE_SCALE_VIEW = `${HIVE_SCALE_LIST_VIEW}/:hiveScaleId`
export const HIVE_MEASUREMENT_DETAIL_VIEW = `${HIVE_SCALE_VIEW}/:metric`
export const HIVE_MEASUREMENT_LIST_VIEW = `${HIVE_SCALE_VIEW}/:metric/list`
